<template>
    <div class="page home-page px-md-8">
        <transition name="fade-transition">
            <v-container v-if="loadedOnce" class="py-lg-8 px-0">
                <v-row :class="{'ma-0': phoneOnly}">
                    <v-col cols="12" lg="8" :class="{'py-0': phoneOnly}">
                        <v-alert v-if="unpaidBillsCount > 0 && allowBillsPage" type="error" outlined style="background-color: #fff!important" v-ripple @click="$router.push({name: 'bills'})" class="e-link">
                            <span class="font-weight-bold medium-text">لديك فاتورة مستحقة في انتظار الدفع</span>
                        </v-alert>
                        <v-card flat class="px-3 bordered mb-4">
                            <v-card-title class="d-flex w-100 justify-space-between" :class="{'px-2': capRunning}">
                                <div style="line-height: 1!important" :class="{'d-flex justify-space-between w-100 flex-grow-1': capRunning}">
                                    <div>
                                        <img :src="storeData.logo" style="height: 28px; width: auto;" />
                                    </div>
                                    <div v-if="allowBillsPage" class="mt-1">
                                        <v-chip v-if="storeData.subscription === 'free'" label small style="height: 22px">خطة مجانية</v-chip>
                                        <v-chip v-else-if="storeData.subscription === 'premium'" color="orange darken-2" dark label small style="height: 22px">
                                            <v-icon size="16" class="me-1" left>mdi-crown</v-icon>
                                            <span>خطة مميزة</span>
                                        </v-chip>
                                        <v-chip v-else label small style="height: 22px">{{storeData.subscription}}</v-chip>
                                    </div>
                                </div>
                                <div v-if="!capRunning">
                                    <v-btn depressed as="a" target="_blank" :href="storeData.store_url" :color="storeData.primary_color || 'primary'" dark>
                                        <v-icon left size="21">mdi-open-in-new</v-icon> <!-- store-outline -->
                                        <span>فتح المتجر</span>
                                    </v-btn>
                                </div>
                            </v-card-title>
                            <!-- <v-card-text>
                                هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة التي يقرأها. ولذلك يتم استخدام طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام "هنا يوجد محتوى نصي، هنا يوجد محتوى نصي" فتجعلها تبدو (أي الأحرف) وكأنها نص مقروء. العديد من برامح النشر المكتبي.
                            </v-card-text> -->
                        </v-card>

                        <v-list v-if="capRunning" flat class="bordered py-0">
                            <v-list-item v-ripple="{class: 'ripple--color'}" @click="openUrl(storeData.store_url)" class="py-1">
                                <v-list-item-icon class="me-5">
                                    <v-icon :color="storeData.primary_color || 'primary'">mdi-store-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>زيارة المتجر على الويب</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon class="my-auto">
                                    <v-icon color="grey" size="22">mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-ripple="{class: 'ripple--color'}" class="py-1" :to="{name: 'orders'}">
                                <v-list-item-icon class="me-5">
                                    <v-icon color="primary">mdi-cart-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>عرض الطلبات</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon class="my-auto">
                                    <v-icon color="grey" size="22">mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-ripple="{class: 'ripple--color'}" class="py-1" :to="{name: 'products'}">
                                <v-list-item-icon class="me-5">
                                    <v-icon color="indigo">mdi-package-variant-closed</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>قائمة المنتجات</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon class="my-auto">
                                    <v-icon color="grey" size="22">mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item v-ripple="{class: 'ripple--color'}" class="py-1" :to="{name: 'store'}">
                                <v-list-item-icon class="me-5">
                                    <v-icon color="purple">mdi-store-cog-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>إعدادات المتجر الإلكتروني</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon class="my-auto">
                                    <v-icon color="grey" size="22">mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list>
                        
                        <v-row class="my-4">
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="الطلبات" :value="stats.orders.all" color="strong-text" icon="mdi-cart-outline" default-period="month" />
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="الطلبات الجارية" :value="stats.orders.pending" color="primary" icon="mdi-cart-outline" default-period="month" />
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="الطلبات المكتملة" :value="stats.orders.completed" color="success" icon="mdi-cart-check" default-period="month" />
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="الطلبات الملغية" info="تشمل كل الطلبات الملغية بما فيها المرتجعة" :value="stats.orders.canceled" color="error" icon="mdi-cart-outline" default-period="month" />
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="المبيعات" money :info="subscription === 'advanced' ? 'لم يتم حساب خصومات الكوبون في هذه الإحصائية' : undefined" :value="stats.sales.completed" color="orange darken-2" icon="mdi-cash-check" default-period="month" />
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="المبيعات الغير مكتملة" money :value="stats.sales.pending" color="blue-grey" icon="mdi-cash-multiple" default-period="all" />
                            </v-col>
                            <v-col v-if="subscription === 'advanced'" cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="خصومات الكوبونات" info="إجمالي الخصومات المطبقة على الطلبات المكتملة باستخدام كوبونات الخصم" money :value="stats.coupon_discounts" color="error darken-1" icon="mdi-cash-minus" default-period="month" />
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="المنتجات" :value="stats.products" color="strong-text" icon="mdi-package-variant-closed"/>
                            </v-col>
                            <v-col cols="12" lg="6" :class="{'py-1': phoneOnly}">
                                <stat-card flat label="العملاء" :value="stats.customers" color="indigo darken-1" icon="mdi-account-group-outline"/>
                            </v-col>
                        </v-row>

                        <!-- <v-card flat class="bordered">
                            <v-card-text>

                            </v-card-text>
                        </v-card> -->

                        <v-card flat class="bordered">
                            <v-card-title class="medium-title py-5">
                                <v-icon color="strong-text" class="me-2">mdi-cart-outline</v-icon>
                                <span>الطلبات الأخيرة</span>
                            </v-card-title>
                            <v-divider style="opacity: 0.75"></v-divider>
                            <v-card-text>
                                <div v-if="lastOrders && lastOrders.length">
                                    <v-list class="py-0">
                                        <template v-for="(order, i) in lastOrders">
                                            <order-list-item :order="order" :key="order.id" />
                                            
                                            <v-divider v-if="i < lastOrders.length-1" inset :key="'divider' + order.id" style="opacity: 0.6" />
                                        </template>
                                    </v-list>
                                    <v-btn depressed block color="surface2" :to="{name: 'orders'}" class="primary--text">
                                        عرض كل الطلبات
                                        <v-icon right class="ms-2" size="20">mdi-chevron-left</v-icon>
                                    </v-btn>
                                </div>
                                <div v-else>
                                    <v-alert dense text color="blue-grey" type="info">
                                        <div class="details-text">لا يوجد طلبات حتى اﻵن</div>
                                    </v-alert>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <div :style="pcOnly ? 'position: sticky; top: 85px' : ''">
                            <v-card v-if="stats" flat class="bordered mb-4 px-6 px-lg-8 py-6">
                                <div class="d-flex align-center">
                                    <v-avatar class="me-5" size="70" color="orange lighten-5">
                                        <v-icon size="36" color="orange darken-3">mdi-cash-check</v-icon>
                                    </v-avatar>
                                    <div class="flex-grow-1">
                                        <div class="medium-text muted--text mb-1">مبيعات الشهر الحالي</div>
                                        <div>
                                            <b style="font-size: 1.8rem">{{moneyFormat(stats.sales.completed.month)}}</b>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                            <v-card flat class="bordered">
                                <v-card-title class="medium-title py-4">
                                    <v-icon color="strong-text" class="me-2">mdi-chevron-double-up</v-icon>
                                    <span>المنتجات اﻷكثر مبيعاً</span>
                                </v-card-title>
                                <v-divider style="opacity: 0.8"></v-divider>

                                <v-card-text class="px-0">
                                    
                                    <v-list class="py-0">
                                        <template v-for="(product, i) in mostOrderedProducts">
                                            <v-list-item :key="product.id" class="px-5" :to="{name: 'product', params: {id: product.id}}" v-ripple="phoneOnly ? {class: 'ripple--color'} : false">
                                                <v-list-item-avatar tile size="50" class="me-5">
                                                    <v-img :src="product.main_image_url"></v-img>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{product.name}}</v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        <div class="d-flex align-center" style="line-height: 1">
                                                            <v-chip small label outlined style="height: 20px" class="px-2 me-2">
                                                                <v-icon class="me-1">mdi-cart-outline</v-icon>
                                                                <span>{{product.orders_count}} طلب</span>
                                                            </v-chip>
                                                            <v-rating :value="product.overall_rating || 0" color="amber" dense half-increments empty-icon="mdi-star-outline" background-color="grey lighten-1" readonly size="16" ></v-rating>
                                                        </div>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            
                                            <v-divider v-if="i < mostOrderedProducts.length-1" inset :key="'divider' + product.id" style="opacity: 0.6" />
                                        </template>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </div>

                        
                    </v-col>
                </v-row>
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import OrderListItem from '@/components/custom/order-list-item'
import StatCard from '@/components/default/stat-card'
import AppAPI from '@/app-api'

export default {
    name: "Home",
    components: {
        OrderListItem,
        StatCard
    },
    data(){
        return {
            loading: false,
            loadedOnce: false,
            stats: null,
            lastOrders: null,
            mostOrderedProducts: null,
        }
    },
    computed: {
        ...GlobalComputed,
        allowBillsPage(){
            return this.platform !== 'ios' || this.appData.ios_show_bpage;
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        openUrl(url){
            window.open(url, '_system');

            /* if (this.capRunning){
                AppAPI.openUrl(url);
            }else{
                window.open(url, '_blank');
            } */
        },
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getStoreHomeData').then(response=>{
                    const lastOrders = response.data.last_orders;
                    this.lastOrders = lastOrders;
                    const stats = response.data.stats;
                    this.stats = stats;
                    const mostOrderedProducts = response.data.most_ordered_products;
                    this.mostOrderedProducts =  mostOrderedProducts;

                    if (!this.loadedOnce){
                        this.loadedOnce = true;
                    }
                    this.loading = false;

                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل بيانات الصفحة', 'error');
                })
            }
        }
    },
    mounted(){
        if (this.$route.query.ToK){
            window.localStorage.removeItem('tK');
            window.location.reload();
        }
        this.loadData();
    }
};
</script>
